import React from 'react'
import { connect } from 'react-redux'
import { MenuItemLink, getResources } from 'admin-on-rest'
import VehicleIcon from 'material-ui/svg-icons/maps/directions-car'
import UserIcon from 'material-ui/svg-icons/social/person'
import TransactionIcon from 'material-ui/svg-icons/action/payment'
import DepositIcon from 'material-ui/svg-icons/editor/monetization-on'
import InvoiceIcon from 'material-ui/svg-icons/action/description'
import GasStationIcon from 'material-ui/svg-icons/maps/local-gas-station'
import SettingsIcon from 'material-ui/svg-icons/action/settings'
import OrganizationIcon from 'material-ui/svg-icons/communication/business'
import DeletedUserIcon from 'material-ui/svg-icons/action/highlight-off'
import MoneyTransferIcon from 'material-ui/svg-icons/editor/attach-money'

const Menu = ({ resources, onMenuTap, logout }) => (
  <div>
    <MenuItemLink 
      to='/gasStation'
      primaryText='Postos'
      onClick={onMenuTap}
      leftIcon={<GasStationIcon />}
    />
    <MenuItemLink 
      to='/organization'
      primaryText='Empresas'
      onClick={onMenuTap}
      leftIcon={<OrganizationIcon />}
    />
    <MenuItemLink
      to='/vehicle'
      primaryText='Veículos'
      onClick={onMenuTap}
      leftIcon={<VehicleIcon />}
    />
    <MenuItemLink
      to='/user'
      primaryText='Usuários'
      onClick={onMenuTap}
      leftIcon={<UserIcon />}
    />
    <MenuItemLink
      to='/deletedUser'
      primaryText='Usuários Excluídos'
      onClick={onMenuTap}
      leftIcon={<DeletedUserIcon />}
    />
    <MenuItemLink
      to='/transaction'
      primaryText='Transações'
      onClick={onMenuTap}
      leftIcon={<TransactionIcon />}
    />
    <MenuItemLink
      to='/balanceDeposit'
      primaryText='Depósitos'
      onClick={onMenuTap}
      leftIcon={<DepositIcon />}
    />
    <MenuItemLink
      to='/moneyTransfer'
      primaryText='Pagamentos'
      onClick={onMenuTap}
      leftIcon={<MoneyTransferIcon />}
    />
    <MenuItemLink
      to='/reports'
      primaryText='Relatórios'
      onClick={onMenuTap}
      leftIcon={<InvoiceIcon />}
    />
    <MenuItemLink
      to='/settings'
      primaryText='Configurações'
      onClick={onMenuTap}
      leftIcon={<SettingsIcon />}
    />
    {logout}
  </div>
)

const mapStateToProps = state => ({
    resources: getResources(state)
})

export default connect(mapStateToProps)(Menu)



// WEBPACK FOOTER //
// ./src/menu.js